const ReissueForm1 = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'130px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'returnExchange.type', //类型
            key:'type',
            type:'select',  
            // required:true,
            disabled:true,
            width:'420px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    label:'order.reissue',
                    value:3,
                },
            ]
        },
        {
            name:'returnExchange.status', // 状态
            key:'status',
            type:'select',  
            disabled:true,
            // required:true,
            width:'420px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    label:'order.replenishing',
                    value:5,
                },
            ]
        },
        {
            name:'returnExchange.source', // 来源
            key:'source',
            type:'input',   
            disabled:true,
            width:'420px',
        },
    ]
}

const ReissueForm2 = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'130px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'returnExchange.backReasonType', // 补寄原因类型
            key:'back_reason_type', 
            type:'select',
            required:true,
            width:'420px',
            placeholder:'base.select',
        },
        {
            name:'returnExchange.backReason', // 补寄原因
            key:'back_reason',
            type:'textarea',   
            allowClear:true,
            required:true,
            showWordLimit:true,
            maxLength:150,
            width:'420px',
            placeholder:'base.input',
        },
        {
            name:'order.reissueTimestamp', // 补寄发货时间
            key:'swap_timestamp_plan',
            type:'date',   
            allowClear:true,
            required:true,
            width:'420px',
        },
        {
            name:'returnExchange.courierType', // 补寄物流公司
            key:'swap_courier_type',
            type:'select',   
            allowClear:true,
            // required:true,
            // disabled:true,
            width:'420px',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'returnExchange.courierNo', // 补寄物流单号
            key:'swap_courier_no',
            type:'input',   
            allowClear:true,
            disabled:true,
            // required:true,
            width:'420px',
            placeholder:'base.input',
        },
        // {
        //     name:'order.instruction', // 备注
        //     key:'instruction',
        //     type:'textarea',   
        //     allowClear:true,
        //     showWordLimit:true,
        //     maxLength:150,
        //     width:'420px',
        //     placeholder:'base.input',
        // },
    ]
}

ReissueForm1.formField.forEach(item=>{
    ReissueForm1.formData[item.key] = ''
})

ReissueForm2.formField.forEach(item=>{
    ReissueForm2.formData[item.key] = ''
})

export {
    ReissueForm1,
    ReissueForm2,
}